<!-- Requests -->
<div
  placement="bottom right"
  class="btn-group"
  [class.active]="active([tabRoute('topics')])"
  [popover]="activeRequestMessage()"
  triggers="mouseenter:mouseleave"
  placement="top"
>
  <button
    type="button"
    class="post-tabs-button with-text"
    [routerLink]="tabRoute('topics')">
    Requests
    <span
      class="fas fa-exclamation-circle text-danger"
      tooltip="Please create a request to start receiving great content."
      *ngIf="activeRequests === 0"
    >
    </span>
    <span *ngIf="activeRequests > 0">
      ({{activeRequests}})
    </span>
  </button>
</div>

<!-- Submissions, Purchases, etc.. -->
<div
  placement="bottom right"
  class="btn-group"
  [class.active]="active([tabRoute('submissions')])"
  [popover]="queueSubsMessage()"
  triggers="mouseenter:mouseleave"
  placement="top"
>
  <button
    type="button"
    class="post-tabs-button with-text"
    [routerLink]="tabRoute('submissions')">
    Submissions
    <span *ngIf="customer.queuedPostsCount > 0">
      ({{customer.queuedPostsCount}})
    </span>
  </button>
</div>

<!-- Topic ideas -->
<div
  *ngIf="customer?.subscription?.plan?.code != 'video'"
  placement="bottom right"
  class="btn-group"
  [class.active]="active([tabRoute('proposed_topics')])"
  [popover]="topicIdeasMessage()"
  triggers="mouseenter:mouseleave"
  placement="top"
>
  <button
    type="button"
    class="post-tabs-button with-text"
    [routerLink]="tabRoute('proposed_topics')">
    Topic Ideas
    <span *ngIf="customer.proposedKeywordsCount > 0">
      ({{customer.proposedKeywordsCount}})
    </span>
  </button>
</div>

<!-- More -->
<div
  dropdown
  placement="bottom right"
  class="btn-group"
  [class.active]="active([
    tabRoute('business_info'),
    tabRoute('plan'),
    tabRoute('multipass-plan'),
    tabRoute('delivery_options')])">
  <button
    dropdownToggle
    class="post-tabs-button with-text dropdown-toggle"
    [class.no-caret]="moreAlert()">
    {{postTabTitleFor('more')}}
    <i class="more-alert-icon" [ngClass]="moreAlert()?.class" *ngIf="moreAlert()"></i>
  </button>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
    <li><a class="dropdown-item" [routerLink]="tabRoute('business_info')">
      <i class="fas fa-briefcase mr-2"></i>
      Business Info
    </a></li>
    <li><a class="dropdown-item" [routerLink]="tabRoute('delivery_options')">
      <i class="fas fa-paper-plane mr-2" [ngClass]="bpsPreferencesAlert()?.class"></i>
      Delivery Options
    </a></li>
    <li *ngIf="!customer?.multipass"><a *ngIf="customer?.state !== 'expired'" [routerLink]="tabRoute('plan')" class="dropdown-item">
      <i class="fas fa-retweet mr-2"></i>
      Change Plan
    </a></li>
    <li *ngIf="customer?.multipass"><a *ngIf="customer?.state !== 'expired'" [routerLink]="tabRoute('multipass-plan')" class="dropdown-item">
      <i class="fas fa-retweet mr-2"></i>
      Change Plan
    </a></li>
    <li><a class="dropdown-item" *ngIf="['active', 'canceled', 'paused'].includes(customer?.subscription?.state)" href="/customers/{{customer.id}}/subscription">
      <i class="far fa-list-alt mr-2"></i>
      Subscription Status
    </a></li>
    <li><a *ngIf="demo" href (click)="clearCustomer()" class="dropdown-item text-brick-red">
      Demo Mode: Clear Subscription
    </a></li>
  </ul>
</div>
